import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { toast } from 'react-toastify';

import {
  Container,
  Row,
  Card,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody
} from 'reactstrap';
import { ErrorMessage } from '@hookform/error-message';
import { useHistory } from 'react-router-dom';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ReactButton from 'components/Buttons/ReactButton';
import ConfigurationService from '../../SystemParams/services';
import FlexSelect from 'components/Inputs/FlexSelect';
import { useParams } from 'react-router';
const errorFormMessage = (message) => <p style={{ color: 'red' }}>{message}</p>;

const ChatGPTConfigForm = () => {
  const { id } = useParams();

  const { control, handleSubmit, errors, reset, setValue } = useForm();
  const history = useHistory();

  const getData = async () => {
    try {
      const response = await ConfigurationService.getAIConfigById(id);
      const data = response?.data?.data;
      reset(data);
      return;
    } catch (error) {
      console.error('Error:', error);
      toast.error('Erro ao carregar informações', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    }
  }, [id]);
  function handleCancelAction() {
    history.push('/admin/configuration');
  }

  const onSubmit = (data) => {
    if (id) {
      ConfigurationService.putAIConfig(data, id)
        .then(() => {
          toast.success('Configuração alterada com sucesso!');
          history.push('/admin/chat/IAconfiguration');
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || 'Erro ao editar', {
            autoClose: 3000,
            closeOnClick: true
          });
        });

      return;
    }
    ConfigurationService.postAIConfig(data)
      .then(() => {
        toast.success('Configuração salva com sucesso!');
        history.push('/admin/chat/IAconfiguration');
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || 'Erro ao salvar', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  return (
    <>
      <SimpleHeader name="Form validation" parentName="Forms" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">{`ChatGPT | OpenAI`}</h3>
                </CardHeader>
                <CardBody>
                  <Form
                    className="needs-validation"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <Row>
                      <Col md="6">
                        <label className="form-control-label">
                          Nome do Canal
                        </label>

                        <Controller
                          as={Input}
                          control={control}
                          name="name_channel"
                          rules={{
                            required: 'Campo obrigatório'
                          }}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="name_channel"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>

                      <Col md="6">
                        <label className="form-control-label">Modelo</label>

                        <Controller
                          render={(props) => (
                            <FlexSelect
                              isClearable={true}
                              dataOptions={[
                                {
                                  label: 'gpt-3.5-turbo',
                                  value: 'gpt-3.5-turbo'
                                },
                                { label: 'gpt-4', value: 'gpt-4' },
                                { label: 'gpt-4-turbo', value: 'gpt-4-turbo' },
                                { label: 'gpt-4o', value: 'gpt-4o' },
                                { label: 'gpt-4o-mini', value: 'gpt-4o-mini' }
                              ]}
                              isMulti={false}
                              closeMenuOnSelect={true}
                              value={props.value}
                              valueController={setValue}
                              fieldName="model"
                              labelName="label"
                              valueName="value"
                              minHeight="1rem"
                            />
                          )}
                          control={control}
                          name="model"
                          rules={{
                            required: 'Campo obrigatório'
                          }}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="model"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <label className="form-control-label">
                          Project API Key(Token)*
                        </label>

                        <Controller
                          as={Input}
                          control={control}
                          name="apikey"
                          rules={{
                            required: 'Campo obrigatório'
                          }}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="apikey"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                      <Col md="6">
                        <label className="form-control-label">Project Id</label>

                        <Controller
                          as={Input}
                          control={control}
                          name="project_id"
                          rules={{
                            required: 'Campo obrigatório'
                          }}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="project_id"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <label className="form-control-label">
                          Assistant Id
                        </label>

                        <Controller
                          as={Input}
                          control={control}
                          name="assintant_id"
                          rules={{
                            required: 'Campo obrigatório'
                          }}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="assintant_id"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>

                      <Col md="6">
                        <label className="form-control-label">Intruções</label>

                        <Controller
                          as={Input}
                          type="textarea"
                          rows="8"
                          control={control}
                          name="instruction"
                          rules={{
                            required: 'Campo obrigatório'
                          }}
                          defaultValue=""
                        />
                        <ErrorMessage
                          errors={errors}
                          name="instruction"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                    </Row>
                    <hr />
                    <ReactButton btnColor="confirmation" type="submit">
                      Salvar
                    </ReactButton>
                    <ReactButton
                      btnColor="cancelation"
                      onClick={() => handleCancelAction()}
                    >
                      Cancelar
                    </ReactButton>
                  </Form>
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default ChatGPTConfigForm;
